import { SessionContext } from '../Contexts/SessionContext/SessionContext';
import { useEffect, useState, useContext, Dispatch, SetStateAction } from 'react';
import httpClient from './useHttpClient';
import { useLocation, useParams } from 'react-router-dom';
import Session from '../Entities/Session';
import { EXTERNAL_ID_TOKEN, EXTERNAL_CURRENT_USER, EXT_TOKEN_CREATION, EXTERNAL_ID_TOKEN_HASH } from '../Constants/OtpConstant';
import useGetOtpUrl from './useGetOtpUrl';

const getHashFromUrl = (str: any) => {
    //console.log('getHashFromUrl: str', str);

    const query = str.substr(1);
    const result = {} as any;

    query.split('&').forEach(function (part: any) {
        const item = part.split('=');
        result[item[0]] = decodeURIComponent(item[1]);
    });

    return result;
};

const useGetOTPSession = (): [boolean, boolean, boolean] => {
    //const [otp] = useGetOtpUrl();

    const { session, setSession } = useContext(SessionContext);
    const [isAuthenticated, setAuthenticated] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [isUnauthorized, setIsUnauthorized] = useState(false);

    const location = useLocation();

    // console.log('useGetOTPSession: document.referrer', document.referrer);
    // console.log('location.hash', location.hash);

    // console.log('useGetOTPSession: document.referrer === "https://otp.nih.gov/"', document.referrer === 'https://otp.nih.gov/');
    // console.log('useGetOTPSession: location.hash === ""', location.hash === '');

    // if (document.referrer === 'https://otp.nih.gov/' && location.hash === '') {
    //     console.log('TRUE');
    //     window.location.href = otp;
    //     //window.location.reload();
    // } else {
    //     console.log('FALSE');
    // }

    const params = useParams();
    let body = {} as any;
    let canAuthenticate = false;

    //console.log('location', location);
    //console.log('params', params);

//location.hash = '#id_token=eyJhbGciOiJSUzI1NiIsImtpZCI6Ijg3OEU2RUIzNURGNTE3NzUwRDNEMjBBOTJERjkxMkQwRjc0MUQ5RTJSUzI1NiIsIng1dCI6Img0NXVzMTMxRjNVTlBTQ3BMZmtTMFBkQjJlSSIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJodHRwczovL290cC5uaWguZ292IiwibmJmIjoxNjg0ODQ0NDEzLCJpYXQiOjE2ODQ4NDQ0MTMsImV4cCI6MTY4NDg0NDcxMywiYXVkIjoiSW5yb0Rldi51c2VyIiwiYW1yIjpbInB3ZCJdLCJub25jZSI6ImhQUUJELXVjcFA3YzJRdER6UmtGUU1MaGtEeUpVOEZ4b2lGeEhBSE0tQ3MiLCJhdF9oYXNoIjoiZUZnbndGb29NM2FxN19hNmxkdmdfZyIsInNpZCI6Ijk5Rjg2MzA3RjVDMTA3RkE2MzlCRUVGRUM2RkI5QzY3Iiwic3ViIjoicm90N3F3NHhAYmVzdHRlbXBtYWlsLmNvbSIsImF1dGhfdGltZSI6MTY4NDg0NDM2OSwiaWRwIjoibG9jYWwifQ.TLfGY1yj3qhI_ELtnZoh820sSviIG511tqeNSPGm2lMVr1_IOWIv0S7sq87UTRuyiOoDFUZo9BvYkCggBNgOZYJr88qOsAX0tSVXY3t4dMnCVbJFia76xuIB8NKnDjJg_XI_Qxk_7JgCHNqkaFtjDgIvxN5E2clkjELWHT5IfJW1qvX-qvz08I2y3gr3rv2EhcXH8QRLxe9zwTI2nSqes8AKjWFnDcHneYJx3GiRGCH6iQWTzuAaM9_hNfN1f1kgaysM7PiLiYQqkyUah-xQGvyfSQFxGX4t1VYNXR3FgEO8VAUBIysmW_OGq07gQRJ6JyJ8XGEA-AqDQ4odgW4-nbORBggrW0uM9U0bc4ufr2P8nE6fW13QxzdkCEgxoVVY7mYjuhglym-lPQld_RZLpAMkUREfjZn3Rx1iI-7Ei48w1W5AiXg5MmFmc_HMh5XVI_yL-PFd120tZd5gRFkfAnLGX53JTsXHtBPU0CiRYEy3Ob143V5dtCKEfrhkwnbbpw9cu3D2yb7BOXm58FjKrXs-vpMu-ECAYRyh4JSa95y0wBbxz6iLgCXSCa_A_nrUU0BD9tI2TkhKrDiz3_3IWRq8tAtBTfvrrWnJiTZQOif3UYQwYvd4GMZ-FealLdBInYdniMUrLjI5pj033kjI_OLBmoRV7vT1aYfwy_oXBOY&access_token=eyJhbGciOiJSUzI1NiIsImtpZCI6Ijg3OEU2RUIzNURGNTE3NzUwRDNEMjBBOTJERjkxMkQwRjc0MUQ5RTJSUzI1NiIsIng1dCI6Img0NXVzMTMxRjNVTlBTQ3BMZmtTMFBkQjJlSSIsInR5cCI6ImF0K2p3dCJ9.eyJpc3MiOiJodHRwczovL290cC5uaWguZ292IiwibmJmIjoxNjg0ODQ0NDEzLCJpYXQiOjE2ODQ4NDQ0MTMsImV4cCI6MTY4NDg0ODAxMywic2NvcGUiOlsib3BlbmlkIiwib3RwLnVzZXIucHJvZmlsZSJdLCJhbXIiOlsicHdkIl0sImNsaWVudF9pZCI6Iklucm9EZXYudXNlciIsInN1YiI6InJvdDdxdzR4QGJlc3R0ZW1wbWFpbC5jb20iLCJhdXRoX3RpbWUiOjE2ODQ4NDQzNjksImlkcCI6ImxvY2FsIiwic2lkIjoiOTlGODYzMDdGNUMxMDdGQTYzOUJFRUZFQzZGQjlDNjciLCJqdGkiOiIxQzJFMzQyOEQ5NzUzNEUyMjlBQjYwNDlEOEFBNkRBQyJ9.I2R1FZYYiuP8x33vdcTs7PX29I41YPWPlze_r1VZfhLFJhq2cwYg-A1bAg1JDYUMqo9tqyXk3et2oKGVs_DJGeQI6FW4QfYvt-jEyFI3yWOf1Kdyyql-hJQ6RwsYsIPVi1TkRUGV4b73TJGA9GYMOLqnmqyhPWccx4FFFF6ex6oL0bxWZA3dTwR29vBIKiNIyktMVxycnPY3DEA4p8mbcmm_vVkV6nfmM8L41JKXsk5ABOGVX1nEkRJ0G9hqbIZfFPS1xFdR7fggc0b_dtp0jyEMal-Vqjiv2gKMZJuCRffX1XvwJFeaEsF2l8wjSWAGI3Mp3U4ORhLnDX1Z7h87Aut4etL17pE9tX3Am07XrVEbdDrbgroBqVtBCUi7dMQX7ubOE3RAoM66FtXWt2Nj_TbtImt7zrcFVjvlKZ7LkXTyq3K--DDZNahGhc2uLV0kpb0wV1Mbcr1iUqBXw2_ESYy5B4y2kUjxL3xxYThBkBlfbH6z6hTytCVvIy7kp68dT83Y2-iT8IAavOPshuZ-c2ZR4pEw4JSum0KhdPQWx6HODsuBx1SjeBuq36LRgiM_TFkylFA0P6zH3fAntL8gq8tVDvlc1t7rC0M6EWKXaRj7dtaPI-AKwOqoOZmtpH2ebCGOR-HKTGPFrS3L1qaUfgBGZ53PvxNYJEKhcsGiYs0&token_type=Bearer&expires_in=3600&scope=openid%20otp.user.profile&state=WuOkyNd8zYGQupglZZ1N9TYznX5zUbqkKcNQh9WG1nU&session_state=6_7Okj3hq09UHKYolidV665GKTv-gj9CFGemhd0j4yc.080B53D972FEF9A3D3C95F78E46CAC73';

    if (location.hash) {
        const hash = getHashFromUrl(location.hash);
        body = { accTk: hash.access_token, idToken: hash.id_token, refreshToken: '', reserved: '' };
        canAuthenticate = true;
    }

    if (canAuthenticate) {
        // console.log('Logged In params', location.hash);
        // console.log('body', body);
    }

    useEffect(() => {
        canAuthenticate &&
            httpClient('')
                .post('/api/otp/authenticate', body)
                .then((c) => {
                    // console.log('c.data', c.data);
                    // console.log('Logged In params', location.hash);

                    const { otpIdToken, otpUser } = c.data;
                    var otpUserJson = JSON.stringify(otpUser);

                    localStorage.setItem(EXTERNAL_ID_TOKEN, otpIdToken);
                    localStorage.setItem(EXTERNAL_CURRENT_USER, otpUserJson);

                    let newDate = new Date();
                    let date = newDate.getTime();
                    localStorage.setItem(EXT_TOKEN_CREATION, JSON.stringify(date));
                    localStorage.setItem(EXTERNAL_ID_TOKEN_HASH, location.hash);

                    if (c.data.apiSession.apiToken !== '') {
                        setSession(JSON.parse(c.data.apiSession) as Session);

                        window.history.replaceState({}, document.title, '/');

                        setAuthenticated(true);
                        setLoading(false);
                        return;
                    }

                    setAuthenticated(false);
                    setLoading(false);
                })
                .catch((c) => {
                    console.log('FAILED-catch', c);
                    setAuthenticated(false);
                    setLoading(false);
                    setIsUnauthorized(false);
                });
        setLoading(false);
    }, [])

    return [isAuthenticated, isLoading, isUnauthorized];
};

export default useGetOTPSession;